// @ts-nocheck
import { Drawer } from 'antd';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { changeSettlementInfoDrawerProps } from '../../../redux/actions/settlement';
import SharedTable from '../../shared/Table/Table';
import styles from './SettlementInfoDrawer.module.scss';
import { HistoryOutlined, UserOutlined, CommentOutlined, RollbackOutlined } from '@ant-design/icons';
import { OUTCOME_STATUSES, TICKET_STATUSES } from '../../../utils/constants';

const SettlementInfoDrawer = () => {
    const dispatch = useDispatch();

    const { isVisible, logs, type } = useSelector(state => state.settlement.settlementInfoDrawerProps);

    const onClose = async () => {
        dispatch(
            changeSettlementInfoDrawerProps({
                isVisible: false,
            })
        );
    };

    const columns = [
        {
            key: 'username',
            title: (
                <div className={'flex align-center'}>
                    <UserOutlined />
                    <span className={'m-l-2'}>Username</span>
                </div>
            ),
            dataIndex: 'username',
        },
        {
            key: 'settlementTime',
            title: (
                <div className={'flex align-center'}>
                    <HistoryOutlined />
                    <span className={'m-l-2'}>Settlement Time</span>
                </div>
            ),
            dataIndex: 'settlementTime',
            render: settlementTime => moment(settlementTime * 1000).format('DD/MM/YYYY HH:mm:ss'),
        },
        {
            key: 'comment',
            title: (
                <div className={'flex align-center'}>
                    <CommentOutlined />
                    <span className={'m-l-2'}>Comment</span>
                </div>
            ),
            dataIndex: 'comment',
        },
        {
            key: 'settlementStatus',
            title: 'Settlement Status',
            render: ({ settlementStatus, rollback }) => (
                <div className={styles.settlementStatus}>
                    <div>
                        {type === 'ticket'
                            ? TICKET_STATUSES[settlementStatus]
                            : rollback
                            ? OUTCOME_STATUSES[settlementStatus]
                            : TICKET_STATUSES[settlementStatus]}
                    </div>
                    <div>{rollback ? <RollbackOutlined className={styles.settlementHistory} /> : ''}</div>
                </div>
            ),
        },
    ];

    return (
        <Drawer
            title={
                <div className={'flex align-center'}>
                    <HistoryOutlined className={styles.settlementHistory} />
                    <span className={'m-l-4'}>Settlement Information</span>
                </div>
            }
            placement={'right'}
            closable={true}
            destroyOnClose
            onClose={onClose}
            visible={isVisible}
            width={'800px'}
            className={styles.infoDrawerWrapper}
        >
            <SharedTable
                data={logs}
                pagination={false}
                rowKey={row => row.betId}
                scroll={{ x: true }}
                columns={columns}
            />
        </Drawer>
    );
};

export default SettlementInfoDrawer;
